// Module
var code = `<template>
  <require from="./portfolio-overview-by-type-light-widget.scss"></require>

  <div class="portfolio-overview-by-type-light-widget portfolio-overview-by-type-light-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .portfolio-overview-by-type-light-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .portfolio-overview-by-type-light-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .portfolio-overview-by-type-light-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <global-progress if.bind="loading"></global-progress>
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th>Portfolio (MNOK)</th>
          <th class="widget-table__numeric">\${customerService.selectedDates.to | date:'dd.MM.yy'}</th>
          <th class="widget-table__numeric">Andel</th>
          <th class="widget-table__numeric">Endring</th>
          <th class="widget-table__numeric">\${customerService.selectedDates.from | date:'dd.MM.yy'}</th>
          <th class="widget-table__numeric">Kostpris</th>
          <th class="widget-table__numeric">P&L YTD</th>
          <th class="widget-table__numeric">P&L YTD %</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="d of data" class="\${\$last ? 'widget-table__total' : ''}">
          <td if.bind="\$last">TOTAL</td>
          <td else>\${d.group}</td>
          <td class="widget-table__numeric">
            \${d.estimatedValue / 1000000 | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.costPricePercent | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.estimatedValueChange / 1000000 | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.estimatedValueFrom / 1000000 | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.costPrice / 1000000 | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.profitLossYearToDate / 1000000 | numericFormatter:precision}
          </td>
          <td class="widget-table__numeric">
            \${d.profitLossYearToDatePercent | numericFormatter:precision}
          </td>
        </tr>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;